import React from 'react'

import { Button, Modal } from '@mui/material'
import { BiX } from 'react-icons/bi'
import { CheckoutContext } from '../../../contexts/CheckoutContext'

import './stylesMACpf.css'

export default function ModalAddCpf({ modal, ClosedModal }) {
  const { sttCtxChkt, actionsChkt } = React.useContext(CheckoutContext)
  const [cpfValue, setCpfValue] = React.useState(sttCtxChkt.cpfObrigatorio ? sttCtxChkt.cpfObrigatorio : '')

  const formatCPF = value => {
    value = value.replace(/\D/g, '')
    if (value.length > 11) value = value.slice(0, 11)
    if (value.length > 9) value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    else if (value.length > 6) value = value.replace(/(\d{3})(\d{3})(\d{3})/, '$1.$2.$3')
    else if (value.length > 3) value = value.replace(/(\d{3})(\d{3})/, '$1.$2')
    return value
  }

  return (
    <Modal open={modal} className='contain-overlay-sel-cpf' onClose={ClosedModal}>
      <div className='contain-content-sel-cpf'>
        <div className='contain-captura-cupom-cpf'>
          <BiX className='icon-closed-modal' onClick={ClosedModal} />
          <h2 className='text-title-cpf'>Adicione seu CPF</h2>

          <p className='text-label-gray'>Este centro esportivo exige o seu CPF para cumprimento de leis municipais.</p>
          <input
            type='text'
            inputMode='numeric'
            className='input-cupom-cpf'
            value={cpfValue}
            onChange={e => {
              setCpfValue(formatCPF(e.target.value))
            }}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                actionsChkt.ValidCpf(cpfValue)
                e.preventDefault()
              }
            }}
            placeholder='Digite o seu cpf'
          />
          <Button
            variant='contained'
            sx={{
              width: '100%',
              maxWidth: '250px',
              marginBottom: '5px',
            }}
            onClick={() => {
              actionsChkt.ValidCpf(cpfValue)
            }}
          >
            Adicionar CPF
          </Button>
          {sttCtxChkt.cpfObrigatorio ? (
            <Button
              variant='contained'
              sx={{
                backgroundColor: '#FF4D4D',
                color: '#FFF',
                marginBottom: '5px',
                width: '100%',
                maxWidth: '250px',
              }}
              onClick={() => {
                actionsChkt.ValidCpf(null)
              }}
            >
              Remover CPF
            </Button>
          ) : (
            <></>
          )}
        </div>
      </div>
    </Modal>
  )
}
